import e from"./fails.js";var t=e,r=!t(function(){return Object.isExtensible(Object.preventExtensions({}))});export{r as default};
